export class LoginCredential {
    userName: string;
    password: string;
}


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/auth/login/login.credential.ts